import React from "react";

import { TwoColumn } from "../TwoColumn/TwoColumn";
import { OneColumn } from "../OneColumn/OneColumn";
import { NestedContentTeaser } from "../NestedContentTeaser/NestedContentTeaser";

export function RowRenderer({ rowData, hasLightBackground, withGallery}) {
    switch (rowData.type) {
        case "DatoCmsTwoColumn":
            return (
                <TwoColumn
                    key={rowData.id}
                    leftColumn={rowData.leftColumn}
                    rightColumn={rowData.rightColumn}
                    withGallery={withGallery}
                    // hasLightBackground={isLightBg}
                />
            );
        case "DatoCmsOneColumn":
            return (
                <OneColumn
                    key={rowData.id}
                    column={rowData.content}
                    withGallery={withGallery}
                    // hasLightBackground={isLightBg}
                />
            );
        case "DatoCmsNestedContentTeaser":
            return (
                <NestedContentTeaser
                    key={rowData.id}
                    tagline={rowData.tagline}
                    headline={rowData.headline}
                    semanticOfHeadline={rowData.semanticOfHeadline}
                    teaser={rowData.teaser}
                    link={rowData.link}
                    // hasLightBackground={isLightBg}
                />
            );
        default:
            return null;
    }
}
